import { Button } from "./Button";
import { useSFWBuilderHook } from "../../Hooks/use-context-hooks";

import { IconComponent } from "../Icon/IconComponent";
import { useState, useEffect } from "react";
import { logEvent } from "../../Utils/google-analytics";

import { useSearchHook, useLanguageHook } from "../../Hooks/use-context-hooks";
import { isEolProduct, canAddProductToList } from "../../Utils/product-availability";

export const AddToListButton = ({ product }) => {

    const { addItemToBuilderList } = useSFWBuilderHook();
    const { isDesktopSearchState, isMobileSearchState, isHomepageSearchState } = useSearchHook();

    const { translatedText } = useLanguageHook();

      const isEol = isEolProduct(product);
    const canAddToList = canAddProductToList(product);


    const handleAddProductToList = () => {

          if (!canAddToList) return;

        addItemToBuilderList(product); // First, add the product to the list
        //------------------------------
        // FOR GA4
        // ----------------------------- 
        const getSearchData = () => {
            if (Array.isArray(isHomepageSearchState.isSearchResults) && isHomepageSearchState.isSearchResults.length > 0) {
                return {
                    searchQuery: isHomepageSearchState.isSearchInputValue,
                    searchResultsCount: isHomepageSearchState.isSearchResults.length,
                    searchType: 'Homepage_Search',
                    searchedProduct: product.title,
                    searchedProductCategory: product.category,
                    searchedProductSubcategory: product.subcategory,
                };
            } else if (Array.isArray(isMobileSearchState.isSearchResults) && isMobileSearchState.isSearchResults.length > 0) {
                return {
                    searchQuery: isMobileSearchState.isSearchInputValue,
                    searchResultsCount: isMobileSearchState.isSearchResults.length,
                    searchType: 'Nav_Search',
                    searchedProduct: product.title,
                    searchedProductCategory: product.category,
                    searchedProductSubcategory: product.subcategory,
                };
            } else if (Array.isArray(isDesktopSearchState.isSearchResults) && isDesktopSearchState.isSearchResults.length > 0) {
                return {
                    searchQuery: isDesktopSearchState.isSearchInputValue,
                    searchResultsCount: isDesktopSearchState.isSearchResults.length,
                    searchType: 'Nav_Search',
                    searchedProduct: product.title,
                    searchedProductCategory: product.category,
                    searchedProductSubcategory: product.subcategory,
                };
            }
            return null; // No search data available
        };
        const searchData = getSearchData();

        // // Only log event once, depending on whether search data exists
        if (searchData) {

            logEvent('SEARCHED_PRODUCT_ADDED', {
                productName: searchData.searchedProduct,
                productCategory: searchData.searchedProductCategory,
                productSubcategory: searchData.searchedProductSubcategory,
                searchType: searchData.searchType,
                searchQuery: searchData.searchQuery,
                searchResultsCount: searchData.searchResultsCount,
            });

        }
        else {
            logEvent('PRODUCT_ADDED', {
                productName: product.title,
                productCategory: product.category,
                productSubcategory: product.subcategory,
            });
        }


    };
    return (
      
        <Button
            type="button"
            buttonStyleType="primaryAction"
            buttonTextType="action"
            onClick={handleAddProductToList}
            animationType="bounceEffect"
            disabled={isEol ? true : false}
        >
            {/* Add to list */}
            {/* {translatedText.ctaAddToList} */}
                {isEol ? "EOL" : translatedText.ctaAddToList}
        </Button>
    );

};



// USED ON BUILDER CARD
export const RemoveFromListButtonIcon = ({ product, iconSizeType, iconColor }) => {

    const iconSizeMap = {
        large: 'largeRemoveProductIcon',
        small: 'smallRemoveProductIcon'
    }
    const iconSvgColorMap = {
        white: 'white',
    }
    const { removeItemFromBuilderList } = useSFWBuilderHook();

    const handleRemoveProductFromList = () => {
        removeItemFromBuilderList(product);
    }
    const iconStyleType = iconSizeMap[iconSizeType];
    const svgColor = iconSvgColorMap[iconColor];

    return <IconComponent onClick={handleRemoveProductFromList}
        iconStyleType={iconStyleType}
        iconType='xClose'
        svgFill={svgColor}
    />

};



export const RemoveFromListButton = ({ product, buttonStyleType = 'primary', plainTextButton = false }) => {

    const { removeItemFromBuilderList } = useSFWBuilderHook();
    const { translatedText } = useLanguageHook();
    const handleRemoveProductFromList = () => {
        removeItemFromBuilderList(product);
    }

    const textOnlyButton = <IconComponent onClick={handleRemoveProductFromList} iconType='xClose' />;
    // <BodyText type="b2" onClick={handleRemoveProductFromList}>Remove</BodyText>;

    const regularButton = <Button
        type="button"
        buttonStyleType={buttonStyleType}
        buttonText="action"
        onClick={handleRemoveProductFromList}
    >

        {translatedText.ctaRemoveFromList}
    </Button>

    // const iconButton = <IconComponent iconType='xClose'></IconComponent>

    return plainTextButton === true ? textOnlyButton : regularButton;
}


